














import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class Loading extends Vue {
  // Props
  @Prop({ default: 3 })
  private size!: number;
  @Prop({ default: 3 })
  private delay!: number;
  @Prop({ default: false })
  private isAbsolute!: boolean;
  @Prop({ default: true })
  private isCentered!: boolean;
  @Prop({ default: true })
  private hasPadding!: boolean;
  // Data
  private isVisible = false;
  // Lifecycle methods
  public created() {
    setTimeout(() => {
      this.isVisible = true;
    }, this.delay);
  }
}
